import { memo, useState, useMemo } from 'react';
import { ConfigContext } from './config-context';
import { DEFAULT_CARDS_PER_PAGE, DEFAULT_MAX_CARDS_PER_COLUMN } from './constants';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigProvider = /*#__PURE__*/memo(({
  children,
  maxCardsPerColumn = DEFAULT_MAX_CARDS_PER_COLUMN,
  onShowMore,
  getDragPermissionsMessageForCard,
  onColumnChange,
  hideQuerySelection = false,
  onErrorCaught,
  CardComponent,
  StyledCardComponent,
  getIsCardShaded,
  onCardClick = emptyFunction,
  renderEmpty,
  renderFooter,
  renderHeaderSummary,
  cardsPerPage = DEFAULT_CARDS_PER_PAGE,
  onColumnMounted,
  onColumnCollapse,
  useReskin = false
}) => {
  const [isDragInProgress, setIsDragInProgress] = useState(false);
  const value = useMemo(() => {
    return {
      maxCardsPerColumn,
      onShowMore,
      getDragPermissionsMessageForCard,
      hideQuerySelection,
      onColumnChange,
      onErrorCaught,
      CardComponent,
      StyledCardComponent,
      getIsCardShaded,
      onCardClick,
      renderEmpty,
      renderFooter,
      renderHeaderSummary,
      cardsPerPage,
      isDragInProgress,
      setIsDragInProgress,
      onColumnMounted,
      onColumnCollapse,
      useReskin
    };
  }, [maxCardsPerColumn, onShowMore, getDragPermissionsMessageForCard, hideQuerySelection, onColumnChange, onErrorCaught, CardComponent, StyledCardComponent, getIsCardShaded, onCardClick, renderEmpty, renderFooter, renderHeaderSummary, cardsPerPage, isDragInProgress, setIsDragInProgress, onColumnMounted, onColumnCollapse, useReskin]);
  return /*#__PURE__*/_jsx(ConfigContext.Provider, {
    value: value,
    children: children
  });
});
ConfigProvider.displayName = 'CDBConfigProvider';
export default ConfigProvider;